export function getDownloadableAgendaEvents({
  events,
  filteredEvents,
  hasActiveFilters,
  visibleMonth
}) {
  if (hasActiveFilters) return filteredEvents;

  const targetMonth = visibleMonth?.getMonth();
  const targetYear = visibleMonth?.getFullYear();
  return events.filter(event => {
    const eventDate = new Date(event?.startsAt);
    return !Number.isNaN(eventDate.getTime()) &&
      eventDate.getMonth() === targetMonth &&
      eventDate.getFullYear() === targetYear;
  }).sort((firstEvent, secondEvent) => (
    new Date(firstEvent.startsAt).getTime() - new Date(secondEvent.startsAt).getTime()
  ));
}

export function getCalendarWeekDays(value) {
  const anchor = value instanceof Date
    ? new Date(value)
    : new Date(`${value}T12:00:00`);
  if (Number.isNaN(anchor.getTime())) return [];

  anchor.setHours(0, 0, 0, 0);
  const mondayOffset = (anchor.getDay() + 6) % 7;
  anchor.setDate(anchor.getDate() - mondayOffset);

  return Array.from({length: 7}, (_, index) => {
    const day = new Date(anchor);
    day.setDate(anchor.getDate() + index);
    return day;
  });
}

export function getWeeklyAgendaEvents(events, weekValue) {
  const weekDays = getCalendarWeekDays(weekValue);
  if (weekDays.length === 0) return [];

  const startsAt = new Date(weekDays[0]);
  const endsAt = new Date(weekDays[6]);
  endsAt.setHours(23, 59, 59, 999);

  return events.filter(event => {
    const eventDate = new Date(event?.startsAt);
    return !Number.isNaN(eventDate.getTime()) && eventDate >= startsAt && eventDate <= endsAt;
  }).sort((firstEvent, secondEvent) => (
    new Date(firstEvent.startsAt).getTime() - new Date(secondEvent.startsAt).getTime()
  ));
}

export function getMinutesOfDay(value) {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date.getHours() * 60 + date.getMinutes();
}

export function layoutOverlappingEvents(events) {
  const positionedEvents = events.map(event => {
    const startMinutes = getMinutesOfDay(event?.startsAt);
    const parsedEndMinutes = getMinutesOfDay(event?.endsAt);
    const endMinutes = parsedEndMinutes !== null && startMinutes !== null && parsedEndMinutes > startMinutes
      ? parsedEndMinutes
      : (startMinutes ?? 0) + 60;
    return {event, startMinutes: startMinutes ?? 0, endMinutes};
  }).sort((firstEvent, secondEvent) => (
    firstEvent.startMinutes - secondEvent.startMinutes ||
    firstEvent.endMinutes - secondEvent.endMinutes
  ));

  const laneEnds = [];
  positionedEvents.forEach(positionedEvent => {
    let lane = laneEnds.findIndex(endMinutes => endMinutes <= positionedEvent.startMinutes);
    if (lane === -1) lane = laneEnds.length;
    laneEnds[lane] = positionedEvent.endMinutes;
    positionedEvent.lane = lane;
  });

  const laneCount = Math.max(laneEnds.length, 1);
  return positionedEvents.map(positionedEvent => ({...positionedEvent, laneCount}));
}
